import React from 'react'
import { Drawer, type DrawerProps } from '@mantine/core'

export type AppDrawerProps = DrawerProps

/** Standard side panel with md padding. */
export default function AppDrawer ({ padding = 'md', ...props }: AppDrawerProps) {
  return <Drawer padding={padding} {...props} />
}
